import React from 'react';
import { Modal, IconButton, SelectionMode, mergeStyleSets, getTheme, getId, FontSizes, FontWeights, Link, DetailsListLayoutMode, ShimmeredDetailsList, Label, IColumn, IPlainCardProps, HoverCardType, HoverCard, mergeStyles, DirectionalHint, MessageBarType, MessageBar, ProgressIndicator, IButton, DefaultButton, MessageBarButton } from '@fluentui/react';

import { UIConstants, isMercuryTenant, isMSSalesTenant, MS_PER_DAY, EXPIRY_WARNING_COLOR, EXPIRY_WARNING_DAYS } from '../../shared/models/Constants';
import { msalAuth } from '../../shared/auth/MsalAuthProvider';
import { IUser } from '../../shared/models/User.model';
import MyAccessStatus from './MyAccessStatus';
import { Utility } from '../../shared/models/Helper';
import AccessAPI from '../../store/AccessAPI';
import { MyAccessResponse } from '../../shared/models/MyCurrentAccess.model';
import _ from 'lodash';
import { AccessRequestSelfRemoval, MyAccessRequestResponse } from '../../shared/models/UserAccess.model';
import { Permission } from '../../shared/models/Mercury';
import ConfigurationAPI from '../../shared/api/Configuration.api';
import ITenant from '../../shared/models/Tenant.model';
import { AllowedAccount } from '../../shared/models/Role.model';
import ViewPermissions from '../../shared/components/ViewPermissions';
import { AllowedAccountByTenant } from "../../shared/models/AllowedAccountTypes";
interface ICurrentAccessProps {
  roleData: any,
  onDismiss: Function;
  tenantId: string;
  mssalesBusiness?: any;
  mssalesSubsidiaries?: any;
  tenantName: string;
}
interface ICurrentAccessState {
  showModal: boolean,
  showRemoveConfirmation: boolean,
  showRemoveRequestConfirmation: boolean,
  roleToRemove: string,
  requestIdToRemove: string,
  removeInProgress: boolean,
  userDetails: IUser,
  MyAccess: MyAccessResponse,
  MercuryAccess: MyAccessRequestResponse,
  showErrorMessage: boolean,
  message: string,
  messageType: MessageBarType,
  autoHideMessage: boolean,
  mercuryPermissionData?: Permission[],
  permissionLevel: string,
  currentApprovedAccessItems: any[],
  hasOEMAccess: boolean,
  OEMSecurityTypeName: string,
  tenantName: string;
  permissionGroup: string;
  allowedAccountTypes: AllowedAccount[];
  hasRolePermissions: boolean;
  clickedRoleName: string;
  clickedBusinessGrp: string;
  clickedRoleId: string;
  showPermissionsModal: boolean;
  accessExpiryReminderWindowDays: number;
}

const formatCamelCase = (text: string): string => {
  return text
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')  // "XMLParser" → "XML Parser"
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')      // "camelCase" → "camel Case"
    .replace(/\b[a-z]/g, (c) => c.toUpperCase())// Capitalize first letter of the word
    .trim();
};

// System attributes that should be filtered out from display
const SYSTEM_ATTRIBUTES = ['UserAlias', 'RoleSetToExpire', 'MSMSA', 'INTUSR', 'MSEC', 'PSEC'];

// Tenant-specific attribute key mappings - only for display name transformation
const ATTRIBUTE_DISPLAY_MAP = {
  'SCOMP': 'Company',
  'PWWAR': 'Geography',
  'MWWAR': 'Geography',
  'PXOS': 'Functional / Exec org Summary',
  'MXOS': 'Functional / Exec org Summary',
  'AccessTypeBU': 'Access Type',
  'AccessTypeEU': 'Access Type',
  'AccessTypeBI': 'Access Type',
  'AccessTypeData': 'Access Type',
  'AccessTypeFinance': 'Access Type',
  'AccessTypeRelia': 'Access Type',
  'AccessTypeSO': 'Access Type',
  'AreaRelia': 'Area',
  'Group': 'Group Name'
};

const theme = getTheme();
const iconButtonStyles = mergeStyleSets({
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px'
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
});
const contentStyles = mergeStyleSets({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch'
  },
  header: [
    theme.fonts.xLargePlus,
    {
      flex: '1 1 auto',
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: 'flex',
      fontSize: FontSizes.xLarge,
      alignItems: 'center',
      fontWeight: FontWeights.semibold,
      padding: '12px 12px 8px 24px'
    }
  ],
  body: {
    flex: '4 4 auto',
    padding: '0 24px 24px 24px',
    overflowY: 'hidden',
    selectors: {
      p: {
        margin: '14px 0'
      },
      'p:first-child': {
        marginTop: 0
      },
      'p:last-child': {
        marginBottom: 0
      }
    }
  }
});


type MyAccessRequestProps = ICurrentAccessProps;

export default class MyAccess extends React.Component<MyAccessRequestProps, ICurrentAccessState> {
  private _titleId: string = getId('title');
  private _subtitleId: string = getId('subText');
  private sapRequestStatusEndPoint: string;
  private removeBtnRefList = [];
  private removeBtnRef;
  private removeRequestBtnRefList = [];
  private removeRequestBtnRef;
  private tenantData: ITenant = null;
  private _onRenderPlainCard = (item: any): JSX.Element => {
    return <MyAccessStatus requestItem={item} {...this.props} ></MyAccessStatus>
  };
  private _onRenderItemColumn = (item: any, index: number, column: IColumn): JSX.Element | React.ReactText => {
    const itemClass = mergeStyles({
      selectors: {
        '&:hover': {
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    });
    const hoverCardClass = mergeStyles({
      selectors: {
        '&:focus': {
          outline: '-webkit-focus-ring-color auto 1px'
        },
      },
    });
    const plainCardProps: IPlainCardProps = {
      onRenderPlainCard: this._onRenderPlainCard,
      renderData: item,
      directionalHint: DirectionalHint.bottomCenter,
      calloutProps: {
        isBeakVisible: true
      }

    };
    if (column.key === 'endDate') {
      if (!item.endDate || item.endDate === 'Not Applicable') {
        return <span>{item.endDate}</span>;
      }
      const endDateTimestamp = new Date(item.originalEndDate ?? item.endDate).getTime();
      const diffInDays = Math.floor((endDateTimestamp - new Date().getTime()) / MS_PER_DAY);
      // Expiry highlight depends only on the role-level allowRenew flag,
      // independent of the accessExpiryReminderWindowDays gate used by the Renew button.
      const isExpiringSoon = item.roleAllowRenew && !isNaN(diffInDays) && diffInDays >= 0 && diffInDays <= EXPIRY_WARNING_DAYS;
      return <span style={isExpiringSoon ? { color: EXPIRY_WARNING_COLOR } : undefined}>{item.endDate}</span>;
    }
    if (column.key === 'action') {
      let hasPendingRequests = this.state.MyAccess.Data.pendingRequests.filter(x => x.role?.roleName == item.role).length > 0
      var todayDate: any = new Date();
      var endDate: any = new Date(item.endDate)
      var diff = Math.abs(todayDate - endDate);
      if (isMercuryTenant(this.state.tenantName)) {
        hasPendingRequests = this.state.MyAccess.Data.pendingRequests.filter(x => x.role?.group + "-" + x.role?.roleName == item.role).length > 0
      }
      return (<>
        {item.allowEdit && <span className={itemClass} aria-label={`${"Edit"}`} hidden={hasPendingRequests} style={{ paddingRight: 10 }}>
          <Link role="button" aria-label={`${UIConstants.ButtonText.Edit} ${item.role}`} onClick={() => this.onEditBtnClick(item, false)} >Edit</Link>
        </span>}
        {item.allowRenew && <span className={itemClass} aria-label={`${"Renew"}`} hidden={hasPendingRequests} style={{ paddingRight: 10 }}>
          <Link role="button" aria-label={`${UIConstants.ButtonText.Renew} ${item.role}`} onClick={() => this.onEditBtnClick(item, true)} >Renew</Link>
        </span>}
        {item.allowRemove && <span>
          <Link role="button" componentRef={(componentRef) => {
            this.removeBtnRefList[index] = componentRef
          }} aria-label={`${UIConstants.ButtonText.Remove} ${item.role}`} onClick={() => this.onRemoveApprovedReqBtnClick(item, this.removeBtnRefList[index])} >{UIConstants.ButtonText.Remove}</Link>
        </span>
        }
      </>
      );
    }
    if (column.key === 'status') {
      if (item.accessType && item.accessType.toUpperCase() === "SAP") {
        return (
          <div className={itemClass}>
            <Link role="link" aria-label={`${item.status} ${item.requestId}`} target="_blank" href={this.sapRequestStatusEndPoint} > {item.status} </Link>
          </div>
        );
      } else {
        return (
          <HoverCard className={hoverCardClass} plainCardProps={plainCardProps} instantOpenOnClick={true} type={HoverCardType.plain}>
            <div role="button" className={itemClass} style={{ 'color': '#0078d4' }} aria-label={`${item.status} ${item.requestId}`} >
              {item.status}
            </div>
          </HoverCard>
        );
      }

    }
    if (column.key === 'remove') {
      return (
        <div>
          <Link role="button" componentRef={(componentRef) => {
            this.removeBtnRefList[index] = componentRef
          }} aria-label={`${UIConstants.ButtonText.Remove} ${item.role}`} onClick={() => this.onRemoveApprovedReqBtnClick(item, this.removeBtnRefList[index])} >{UIConstants.ButtonText.Remove}</Link>
        </div>

      );
    } else if (column.key === 'attributes') {
      return (
        <>
          <span role="note" aria-roledescription={item.attributes ? item.attributes : 'Not Applicable'}>
            {/* {item.attributes ? <span> <strong> {`${item.attributeName}: `}</strong>  {item.attributes} </span> : 'Not Applicable'} */}
            {this.renderScope(item)}
          </span>

        </>

      );
    } else if (column.key === 'removeRequest') {
      return (
        <div>
          <Link role="button" componentRef={(componentRef) => {
            this.removeRequestBtnRefList[index] = componentRef
          }} aria-label={`${UIConstants.ButtonText.Remove} ${item.requestId}`} onClick={() => this.onRemoveInprogressReqBtnClick(item, this.removeRequestBtnRefList[index])} >{UIConstants.ButtonText.Remove}</Link>
        </div>

      );
    } else if (column.key == 'requested for' && this.tenantData?.isExternalAADTenant) {
      return (<div>{(!item.role.includes('Bulk Request') && item.requestedFor == null) ? this.state.userDetails.Alias.split('@')[0] + '@microsoft.com' : (item.requestedFor != null) ? item.requestedFor : 'On Behalf (Bulk Request)'}</div>)
    }

    else if (column.key === 'permissions') {
      if (item.multiAttributes[0].attributeValueText != UIConstants.Global_Roles && item.role != UIConstants.BusinessOwner) {
        let bgName = item.multiAttributes[0].attributeValueText;
        return (
          <div className={itemClass}>
            {item.role.includes('Bulk Request') ? 'NA' :
              < Link role="button" aria-label={'permissions'} onClick={() => {
                this.setState({ showPermissionsModal: true, clickedBusinessGrp: bgName, clickedRoleName: item.role, clickedRoleId: item.roleId });
              }} > View Permissions </Link>}
          </div>
        );
      }
      else {
        return <div>NA</div>
      }
    }

    return item[column.key];
  };

  private renderScope = (item) => {
    if (item.attributes) {
      //TO DO : Generalize for both status
      if (item.multiAttributes && item.multiAttributes.length > 0) { // In Progress status
        return item.multiAttributes.map(attrItem => {
          return <><span> <strong> {`${attrItem.attributeName}: `}</strong>  {attrItem.attributeValueText} </span> <br /></>
        })
      } else { // Approved Status
        return <span> <strong> {`${item.attributeName}: `}</strong>  {item.attributes} </span>
      }
    } else {
      return <span>Not Applicable</span>
    }
  }
  private renderAttributes = (rawScope: string[], attrName: string, multiAttributes: any[]) => {
    const { mssalesSubsidiaries, mssalesBusiness } = this.props;
    multiAttributes.push({
      attributeName: attrName, attributeValueText: rawScope.map(x => {
        let spliValue = x.split(':')
        if (_.last(window.location.pathname.split('/')) == "MSSales") {
          const regex = /^\d+$/;
          let res = "";
          let innerSplitValue = spliValue.length > 1 ? spliValue[1] : spliValue[0];
          if (regex.test(innerSplitValue)) {
            if (attrName == "Business") {
              res = mssalesBusiness.find(x => x.children.find(y => y.value.replace(/'/g, '') == innerSplitValue))?.children.find(x => x.value.replace(/'/g, '') == innerSplitValue).label
            }
            else {
              res = mssalesSubsidiaries.find(x => x.children.find(y => y.value.replace(/'/g, '') == innerSplitValue))?.children.find(x => x.value.replace(/'/g, '') == innerSplitValue).label
            }
          }
          else {
            res = innerSplitValue;
          }
          return res;
        } else if (isMercuryTenant(_.last(window.location.pathname.split('/')))) {
          if (attrName == "Company")
            return spliValue[0] + ":" + spliValue[1];
          return spliValue.length > 1 ? spliValue[1] : spliValue[0];
        } else {
          return attrName == "Region" ? x : spliValue[0] === spliValue[1] ? spliValue[0] : x;
        }
      }).join('; ')
    })
    return multiAttributes
  }
  private processAttributesFromObject = (
    attributesObj: any,
    multiAttributes: any[] = [],
    isMercury: boolean = false,
    permissionGroup: string = '',
    permissionLevel: string = '',
    hasAdditionalAccess: boolean = false
  ): any[] => {

    // Special handling for Mercury Trial Balance & Statutory with additional access
    if (isMercury && permissionGroup == 'Trial Balance & Statutory' && hasAdditionalAccess) {
      const scomp = attributesObj?.['SCOMP'];
      if (Array.isArray(scomp) && scomp.length > 0) {
        multiAttributes = this.renderAttributes(
          scomp,
          ATTRIBUTE_DISPLAY_MAP['SCOMP'] || 'SCOMP',
          multiAttributes
        );
      }
      // Add Statutory flag
      multiAttributes = this.renderAttributes(
        ["Statutory: True"],
        'Statutory',
        multiAttributes
      );
      return multiAttributes;
    }

    // Special handling for Mercury Consolidated GAAP with External Reporting
    if (isMercury && permissionLevel.toString().toLowerCase() == UIConstants.PermissionLevels.ConsolidatedGaap.toLowerCase() && hasAdditionalAccess) {
      multiAttributes = this.renderAttributes(
        ["External Reporting: True"],
        'External Reporting',
        multiAttributes
      );

    }

    if (!attributesObj || Object.keys(attributesObj).length === 0) {
      return multiAttributes;
    }

    // Process all attributes dynamically
    Object.keys(attributesObj).forEach(key => {
      var attrValue = attributesObj[key];

      // Skip system attributes
      if (SYSTEM_ATTRIBUTES.includes(key)) {
        return;
      }

      // Skip empty or null values
      if (!attrValue || (Array.isArray(attrValue) && attrValue.length === 0)) {
        return;
      }

      // Get display name - use mapping, otherwise use key as-is
      const attrName = ATTRIBUTE_DISPLAY_MAP[key] || formatCamelCase(key);

      // Process array values
      if (Array.isArray(attrValue)) {
        multiAttributes = this.renderAttributes(attrValue, attrName, multiAttributes);
      } else {
        // Handle non-array values (e.g., boolean or string)
        multiAttributes.push({
          attributeName: attrName,
          attributeValueText: String(attrValue)
        });
      }
    });

    return multiAttributes;
  }
  private processAttributesFromArray = (
    attributes: any[],
    isMercury: boolean = false,
    roleName: string = ''
  ): { multiAttributes: any[], attr: string | null, attrName: string } => {
    var multiAttributes: any[] = [];
    var attr: string | null = null;
    var attrName = '';

    if (!attributes || attributes.length === 0) {
      return { multiAttributes, attr, attrName };
    }

    // Get the first attribute name for backward compatibility and apply mapping
    const firstAttributeName = attributes[0].attributeName;
    attrName = ATTRIBUTE_DISPLAY_MAP[firstAttributeName] || formatCamelCase(firstAttributeName);

    // Process each attribute dynamically
    attributes.forEach(attribute => {
      // Skip system attributes
      if (SYSTEM_ATTRIBUTES.includes(attribute.attributeName)) {
        return;
      }

      // Skip if no attribute values
      if (!attribute.attributeValues || attribute.attributeValues.length === 0) {
        return;
      }

      // Check if this is a statutory scenario
      var isStatutory = (roleName == 'All companies' ||
        (roleName == 'Specific Companies' && attribute.attributeName != 'Specific Companies'));

      var attributeValueText: string;

      // Handle Mercury External Reporting special case
      if (isMercury && attribute.attributeName == 'External Reporting') {
        attributeValueText = attribute.attributeValues[0].code == "true" ? "True" : "False";
      }
      // Handle Mercury statutory special case
      else if (isMercury && attrName != 'Specific Companies' && attribute.attributeName != 'Specific Companies') {
        attributeValueText = attribute.attributeValues
          .filter(y => y.isRemove != true)
          ?.map(y => isStatutory ? "True" : y.description)
          .join('; ');
      }
      // Handle all other attributes generically
      else {
        attributeValueText = attribute.attributeValues
          .filter(y => y.isRemove != true)
          ?.map(y => {
            // Region specific formatting
            if (attributes[0].attributeName == "Region") {
              return y.code + ':' + y.description;
            }
            // Statutory flag
            if (isStatutory) {
              return "True";
            }
            // Standard code:description format
            return y.code !== y.description ? y.code + ':' + y.description : y.code;
          })
          .join('; ');
      }

      // Apply attribute name mapping
      const displayName = isStatutory ? "Statutory" : (ATTRIBUTE_DISPLAY_MAP[attribute.attributeName] || formatCamelCase(attribute.attributeName));

      multiAttributes.push({
        attributeName: displayName,
        attributeVale: attribute.attributeValues,
        attributeValueText: attributeValueText
      });
    });

    // Build the attr string for backward compatibility - also filter out system attributes
    const scope = attributes
      .filter(x => !SYSTEM_ATTRIBUTES.includes(x.attributeName))
      .map(x =>
        x.attributeValues?.filter(y => y.isRemove != true)?.map(y =>
          y.code !== y.description ? y.code + ':' + y.description : y.code
        )
      );
    attr = scope && scope.length > 0 ? scope.map(x => x).join('; ') : null;

    return { multiAttributes, attr, attrName };
  }

  private onRemoveApprovedReqBtnClick(item, currentRowRemoveBtnRef) {
    this.removeBtnRef = currentRowRemoveBtnRef;
    let _permissionGroup = item.role.includes('-') ? item.role.split('-')[0] : '';
    this.setState({ showRemoveConfirmation: true, roleToRemove: item, permissionLevel: item.permissionLevel, permissionGroup: _permissionGroup });
  }
  private removeApprovedRole(roleId, attributes, permissionLevel, roleAssignmentId) {
    this.setState({ showRemoveConfirmation: false, removeInProgress: true });
    const { tenantId } = this.props;
    if (roleId) {
      let requestData: AccessRequestSelfRemoval =
      {
        tenantId: tenantId,
        roleId: roleId,
        businessGroup: attributes,
        permissionLevel: permissionLevel,
        roleAssignmentId: this.tenantData.isExternalAADTenant ? roleAssignmentId : null
      };
      AccessAPI.removeRoleAccess(requestData).then(async data => {
        if (data.status && data.status === 200) {
          this.setState({ removeInProgress: false });
          this.loadRequestData(tenantId);
        } else {
          if (data.message) {
            this.setState({
              removeInProgress: false, message: data.message,
              messageType: MessageBarType.error, showErrorMessage: true
            });
          }
          else {
            this.setState({ removeInProgress: false, message: UIConstants.Messages.RemoveFailure,
              messageType: MessageBarType.error, showErrorMessage: true
            });
          }
        }
      });
    }
  };

  private onRemoveInprogressReqBtnClick(item, currentRowRemoveBtnRef) {
    this.removeRequestBtnRef = currentRowRemoveBtnRef;
    this.setState({ showRemoveRequestConfirmation: true, requestIdToRemove: item.requestId });
  }

  private removeInprogressRequest(requestId) {
    this.setState({ showRemoveRequestConfirmation: false, removeInProgress: true });
    const { tenantId } = this.props;
    if (requestId) {

      AccessAPI.RemoveInProgressAccessRequest(requestId).then((data) => {
        if (data.status && data.status === 200) {
          this.setState({ removeInProgress: false });
          this.loadRequestData(tenantId);
          // AccessAPI.getMyAccess(tenantId).then(res => {
          //     this.setState({ MyAccess: res , MercuryAccess : res });
          // });
        } else {
          this.setState({
            removeInProgress: false, message: UIConstants.Messages.RemoveFailure,
            messageType: MessageBarType.error, showErrorMessage: true
          });
        }
      });
    }
  };

  private onCancelClick() {
    if (this.removeBtnRef) {
      this.removeBtnRef.focus();
    }
    else if (this.removeRequestBtnRef) {
      this.removeRequestBtnRef.focus();
    }

    this.setState({ showRemoveConfirmation: false, showRemoveRequestConfirmation: false, roleToRemove: null, requestIdToRemove: null });
  }
  private ApprovedAccessColumns = () => {
    let columnDef = [
      { key: 'role', name: 'Role', fieldName: 'role', minWidth: 250, maxWidth: 250, isResizable: false, isMultiline: false },
      { key: 'attributes', name: 'Scope', fieldName: 'attributes', minWidth: 400, maxWidth: 400, isResizable: true, isMultiline: true, onRender: this._onRenderItemColumn }
    ];
    if (!isMercuryTenant(this.state.tenantName) && !isMSSalesTenant(this.state.tenantName)) {
      columnDef.push({ key: 'endDate', name: 'Expiry Date', fieldName: 'endDate', minWidth: Utility.getDynamicColumnSize(100), maxWidth: Utility.getDynamicColumnSize(200), isResizable: false, isMultiline: false, onRender: this._onRenderItemColumn });
    }

    if (this.tenantData?.isExternalAADTenant) {
      let requestdForColumn = { key: 'requested for', name: 'Requested For', fieldName: 'requested for', minWidth: 300, maxWidth: 300, isResizable: true, isMultiline: true, onRender: this._onRenderItemColumn };
      columnDef.splice(2, 0, requestdForColumn);
    }
    columnDef.push({ key: 'action', name: 'Action', fieldName: 'action', minWidth: 100, maxWidth: 100, isResizable: false, onRender: this._onRenderItemColumn, isMultiline: false });
    if (this.state.hasRolePermissions) {
      columnDef.push({ key: 'permissions', name: 'Permissions', fieldName: 'permissions', minWidth: 100, maxWidth: 100, isResizable: false, onRender: this._onRenderItemColumn, isMultiline: false });
    }
    return columnDef;
  }

  private PendingAccessColumns = () => {
    let columnDefs = [
      { key: 'requestId', name: 'Request ID', fieldName: 'requestId', minWidth: 220, maxWidth: 220, isResizable: false },
      { key: 'role', name: 'Role', fieldName: 'role', minWidth: 180, maxWidth: 300, isResizable: true, isMultiline: true },
      { key: 'attributes', name: 'Scope', fieldName: 'attributes', minWidth: 200, maxWidth: 200, isResizable: true, isMultiline: true, onRender: this._onRenderItemColumn },
      { key: 'requestType', name: 'Request Type', fieldName: 'requestType', minWidth: 110, maxWidth: 110, isResizable: false },
      { key: 'requestedBy', name: 'Requested By', fieldName: 'requestedBy', minWidth: 110, maxWidth: 110, isResizable: false },
      { key: 'requestDate', name: 'Requested Date', fieldName: 'requestDate', minWidth: Utility.getDynamicColumnSize(180), maxWidth: Utility.getDynamicColumnSize(180), isResizable: false },
      { key: 'status', name: 'Status', fieldName: 'status', minWidth: 100, maxWidth: 100, isResizable: false, onRender: this._onRenderItemColumn },
      { key: 'removeRequest', name: 'Action', fieldName: 'requestId', minWidth: 100, maxWidth: 100, isResizable: false, onRender: this._onRenderItemColumn }
    ];

    if (this.tenantData?.isExternalAADTenant) {
      let requestdForColumn = { key: 'requested for', name: 'Requested For', fieldName: 'requested for', minWidth: 300, maxWidth: 300, isResizable: true, isMultiline: true, onRender: this._onRenderItemColumn };
      columnDefs.splice(3, 0, requestdForColumn);
    }
    if (this.state.hasRolePermissions) {
      columnDefs.push({ key: 'permissions', name: 'Permissions', fieldName: 'permissions', minWidth: 100, maxWidth: 100, isResizable: false, onRender: this._onRenderItemColumn, isMultiline: false });
    }
    return columnDefs;
  }
  private confirmMsgYesBtnRef = React.createRef<IButton>();
  private alertMsgCloseBtnRef = React.createRef<IButton>();

  constructor(props: any) {
    super(props);
    this.state = {
      showModal: true,
      showRemoveConfirmation: false,
      showRemoveRequestConfirmation: false,
      roleToRemove: null,
      requestIdToRemove: null,
      removeInProgress: false,
      userDetails: null,
      MyAccess: null,
      MercuryAccess: null,
      showErrorMessage: false,
      message: '',
      messageType: MessageBarType.info,
      autoHideMessage: false,
      permissionLevel: '',
      currentApprovedAccessItems: [],
      hasOEMAccess: false,
      tenantName: '',
      OEMSecurityTypeName: '',
      permissionGroup: '',
      allowedAccountTypes: [],
      hasRolePermissions: false,
      showPermissionsModal:false,
      clickedBusinessGrp: null,
      clickedRoleName: null,
      clickedRoleId: null,
      accessExpiryReminderWindowDays: 21
    };
  }
  public componentDidMount() {
    let userAccount = msalAuth.getAccount();
    let user: IUser = { PrincipalId: userAccount.accountIdentifier, Alias: userAccount.userName, Name: userAccount.name };
    const { tenantName } = this.props;
    this.tenantData = Utility.GetTenantData().filter(x => x.TenantName.toUpperCase() == tenantName.toUpperCase())[0];
    this.setState({ userDetails: user, tenantName: tenantName, hasRolePermissions: this.tenantData?.HasRolePermissions || false });
    ConfigurationAPI.GetAccessExpiryReminderWindowDays().then(response => {
      if (response !== null && response !== undefined) {
        this.setState({ accessExpiryReminderWindowDays: response });
      }
    });
    this.ensureDataFetched(this.tenantData);
  }
  private ensureDataFetched(tenantData) {
    const { tenantId } = this.props;
    if (tenantData.TenantName == "MSSales") {
      AccessAPI.GetMSRUserData().then(res => {
        this.setState({ hasOEMAccess: res?.msSalesOEMAccessFlag == 1 ? true : false, OEMSecurityTypeName: res?.oemSecurityTypeName });
        this.loadRequestData(tenantId);
      });
    }
    else {
      if (tenantData.isExternalAADTenant) {
        ConfigurationAPI.getConfigurationByKey(
          UIConstants.Configuration.AllowedAccountTypes
        ).then((response: AllowedAccountByTenant[]) => {
          if (response != null && response.length > 0) {
            let allowedTypes = response.filter(
              (x) =>
                x.tenantName?.toLowerCase() ==
                this.tenantData?.TenantName.toLowerCase()
            );
            this.setState({
              ...this.state,
              allowedAccountTypes:
                allowedTypes?.length > 0
                  ? allowedTypes[0].allowedDomains.map((domain) => {
                    return {
                      AllowedType: domain.allowedType,
                      DomainSuffix: domain.domainSuffix,
                      IsDynamic: domain.isDynamic,
                    } as AllowedAccount;
                  })
                  : [],
            });
          }
        });
      }
      this.loadRequestData(tenantId);
    }
  }
  private renderMessage = () => {
    let { message, messageType, autoHideMessage } = this.state;

    if (autoHideMessage)
      setTimeout(() => { this.setState({ showErrorMessage: false }) }, 3000); // hide message after 3 seconds
    setTimeout(() => {
      this.alertMsgCloseBtnRef.current.focus();
    }, 100) // set the focus to close button
    return <div>
      <MessageBar key='FetchMsg'
        actions={
          <div>
            <MessageBarButton componentRef={this.alertMsgCloseBtnRef} onClick={() => { this.setState({ showErrorMessage: false }) }} >{UIConstants.ButtonText.Ok}</MessageBarButton>
          </div>
        }
        messageBarType={messageType}
        isMultiline={false}
      >
        <span style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{message}</span>
      </MessageBar>
    </div>
  };
  private loadRequestData(tenantId: string) {
    const { tenantName } = this.props;
    if (isMercuryTenant(tenantName)) {
      //    AccessAPI.getMyAccessRequest(tenantId).then(res => {
      //        let MercuryInprogressData = { IsDataLoaded: true, IsSuccess: true, Data: { approvedAccess: null, pendingRequests: res.Data.filter(x => x.status == "InProgress") } };
      //        this.setState({ MercuryAccess: res, MyAccess: MercuryInprogressData });
      //    }); // Call API to Get User Access for Mercury
      AccessAPI.GetMercuryData(tenantName).then(res => {
        this.setState({ mercuryPermissionData: res });
      });
    }
    //else {
    AccessAPI.getMyAccess(tenantId).then(res => {
      this.setState({ MyAccess: res, currentApprovedAccessItems: [] });
    });
    //}
  }

  public render() {
    const { showPermissionsModal, showRemoveConfirmation, showRemoveRequestConfirmation, roleToRemove, requestIdToRemove,
      removeInProgress, MyAccess, showErrorMessage, tenantName, permissionLevel, permissionGroup } = this.state;
    const RemoveConfirmation = (props) => {
      let approvedConfirmationMessage = "";
      if (isMercuryTenant(tenantName) && permissionLevel.includes(UIConstants.PermissionTypes.MercuryBasicAccess)) {
        approvedConfirmationMessage = UIConstants.Messages.BasicRoleRemovalNote;
      }

      else if (isMercuryTenant(tenantName) && permissionGroup == UIConstants.PermissionGroups.PLPlanGroup) {
        approvedConfirmationMessage = UIConstants.Messages.PLPlanRemovalNote;
      }

      else if (isMercuryTenant(tenantName) && permissionLevel.includes(UIConstants.PermissionTypes.MercuryAdvanced)) {
        approvedConfirmationMessage = UIConstants.Messages.AdvanceRoleRemovalNote;
      }

      setTimeout(() => {
        this.confirmMsgYesBtnRef.current.focus();
      }, 200); // set the focus to close button

      return (
        <MessageBar
          messageBarType={MessageBarType.warning}
          isMultiline={false}
          dismissButtonAriaLabel="Close"
          actions={
            <div>
              <DefaultButton style={{ height: 25 }} componentRef={this.confirmMsgYesBtnRef} role="button" onClick={() => {
                if (isMercuryTenant(tenantName)) {
                  this.removeApprovedRole(props.role.role, props.role.attributes, permissionLevel, null);
                }
                else if (this.tenantData.isExternalAADTenant){
                  this.removeApprovedRole(props.role.role, props.role.attributes, permissionLevel, props.role.roleAssignmentId)
                }
                else {
                  props.role.attributeName == "BusinessGroup" ? this.removeApprovedRole(props.role.roleId, props.role.attributes,null,null) : this.removeApprovedRole(props.role.roleId, null, null,null)
                }
              }
              } >Yes</DefaultButton>
              <DefaultButton style={{ height: 25 }} role="button" onClick={() => this.onCancelClick()}>Cancel</DefaultButton>
            </div>
          }
        >
          <div role="alert" >
            {approvedConfirmationMessage + " " + UIConstants.Messages.RemoveRoleConfirmation.replace('#RoleName#', props.role.role)}
          </div>
          {/* <Announced message={UIConstants.Messages.RemoveRoleConfirmation.replace('#RoleName#', props.role.role)} ></Announced> */}
        </MessageBar>)
    };
    const RemoveInprogressReqConfirmation = (props) => {

      setTimeout(() => {
        this.confirmMsgYesBtnRef.current.focus();
      }, 200); // set the focus to close button

      return (<MessageBar
        messageBarType={MessageBarType.warning}
        isMultiline={false}
        dismissButtonAriaLabel="Close"
        actions={
          <div>
            <DefaultButton style={{ height: 25 }} componentRef={this.confirmMsgYesBtnRef} role="button" onClick={() => this.removeInprogressRequest(props.requestId)} >Yes</DefaultButton>
            <DefaultButton style={{ height: 25 }} role="button" onClick={() => this.onCancelClick()}>Cancel</DefaultButton>
          </div>
        }
      >
        <div role="alert" >
          {UIConstants.Messages.RemoveRequestConfirmation.replace('#Request#', props.requestId)}
        </div>
      </MessageBar>)
    };

    return <React.Fragment>

      <Modal titleAriaId={this._titleId} subtitleAriaId={this._subtitleId}
        isOpen={this.state.showModal} onDismiss={() => { this._closeModal(null); }}
        isBlocking={false} containerClassName={contentStyles.container}>
        <div className={contentStyles.header}>
          <span id={this._titleId}><h1 className={"h1"} style={{ paddingLeft: 0, fontSize: 20, margin: 0 }}>{UIConstants.MessageBoxTitle.MyAccessEdit}</h1></span>
          <IconButton styles={iconButtonStyles} iconProps={{ iconName: 'Cancel' }}
            ariaLabel="Close My Access dialog" onClick={() => { this._closeModal(null); }} />
        </div>
        <div id={this._subtitleId} className={contentStyles.body}>
          <div style={{
            height: '60vh',
            width: '90vw',
            overflow: 'auto',
            display: 'block',
            margin: '0 auto',
            marginTop: -15
          }} >
            <br />
            <Label><h2 className={"h2"} style={{ paddingLeft: 0, fontSize: 14, margin: 0 }}>{UIConstants.Labletext.MyApprovedRequest} </h2></Label>
            {(showRemoveConfirmation) && <RemoveConfirmation role={roleToRemove}></RemoveConfirmation>}
            {(showErrorMessage) && this.renderMessage()}
            {(removeInProgress) && <ProgressIndicator label={UIConstants.Messages.SubmitInProgressTitle} description={UIConstants.Messages.SubmitInProgress} />}
            <ShimmeredDetailsList
              setKey="approved-items"
              columns={this.ApprovedAccessColumns()}
              items={this.getApprovedItems()}
              layoutMode={DetailsListLayoutMode.justified}
              selectionMode={SelectionMode.none}
              enableShimmer={!MyAccess?.IsDataLoaded}
              ariaLabelForShimmer="My approved request details is being fetched"
              ariaLabelForGrid="My approved request details"
              listProps={{ renderedWindowsAhead: 10, renderedWindowsBehind: 10 }}
              detailsListStyles={{ root: { overflow: 'visible' } }}
            />
            <br />
            <br />
            {(showRemoveRequestConfirmation) && <RemoveInprogressReqConfirmation requestId={this.state.requestIdToRemove}></RemoveInprogressReqConfirmation>}
            <Label><h2 className={"h2"} style={{ paddingLeft: 0, fontSize: 14, margin: 0 }}>{UIConstants.Labletext.MyPendingAccess}</h2></Label>
            <ShimmeredDetailsList
              setKey="pending-items"
              columns={this.PendingAccessColumns()}
              items={this.getPendingItems()}
              layoutMode={DetailsListLayoutMode.justified}
              selectionMode={SelectionMode.none}
              enableShimmer={!MyAccess?.IsDataLoaded}
              ariaLabelForShimmer="My pending request details is being fetched"
              ariaLabelForGrid="My pending request details"
              listProps={{ renderedWindowsAhead: 10, renderedWindowsBehind: 10 }}
              detailsListStyles={{ root: { overflow: 'visible' } }}
            />
          </div>
        </div>
        {showPermissionsModal && <ViewPermissions businessGroupName={this.state.clickedBusinessGrp} roleName={this.state.clickedRoleName} roleId={this.state.clickedRoleId} tenantId={this.tenantData?.TenantId} {...this.props} onDismiss={() => { this.setState({ showPermissionsModal: false }) }} />}
      </Modal>
    </React.Fragment>
  };

  private _closeModal = (data: any = null, isRenew: boolean = false): void => {
    this.setState({ showModal: false, showErrorMessage: false });
    const { tenantName } = this.props;

    if (data && isMercuryTenant(tenantName) || tenantName == UIConstants.Tenant.Alfred || tenantName == UIConstants.Tenant.MDS) {
      this.props.onDismiss(data, isRenew);
    } else if (data != null && data.length > 0 && data.length != undefined) {
      this.props.onDismiss(data, isRenew);
    }
    else if (data != null) {
      // All other tenants pass single object
      this.props.onDismiss(data, isRenew);
    }
    else {
      this.props.onDismiss();
    }

  };

  private getApprovedItems = () => {
    var { currentApprovedAccessItems, MyAccess, mercuryPermissionData, hasOEMAccess, OEMSecurityTypeName } = this.state;
    const { roleData, tenantName } = this.props;
    let myAccessData = null;
    let approvedAccess = [];
    var allowEdit = false;
    // Mercury Tenant Processing
    if (isMercuryTenant(tenantName) && MyAccess && MyAccess.Data && mercuryPermissionData) {
      myAccessData = MyAccess.Data.approvedAccess;
      if (myAccessData) {
        for (const myAccessItem of myAccessData) {
          var multiAttributes: any[] = [];
          var attributeValueString = '';
          var attrName = '';

          // Process attributes dynamically using the new generic method
          if (myAccessItem.Attribute || (myAccessItem.PermissionGroup == 'Trial Balance & Statutory' && myAccessItem.HasAdditionalAccess)) {
            multiAttributes = this.processAttributesFromObject(
              myAccessItem.Attribute,
              multiAttributes,
              true, // isMercury
              myAccessItem.PermissionGroup,
              myAccessItem.PermissionLevel,
              myAccessItem.HasAdditionalAccess
            );

            // Set attrName from first attribute if available
            if (multiAttributes.length > 0) {
              attrName = multiAttributes[0].attributeName;
              attributeValueString = multiAttributes[0].attributeValueText;
            }

            if (myAccessItem.PermissionGroup == 'Trial Balance & Statutory' && myAccessItem.HasAdditionalAccess) {
              attrName = 'Statutory';
              attributeValueString = 'Statutory: True';
            }
          }

          allowEdit = myAccessItem.AllowEdit;
          var diffInDays = Math.floor((new Date(myAccessItem.EndDate).getTime() - new Date().getTime()) / MS_PER_DAY);
          var roleAllowRenew = !!myAccessItem.AllowRenew;
          var allowRenew = roleAllowRenew && diffInDays <= this.state.accessExpiryReminderWindowDays;
          var endDate = new Date(myAccessItem.EndDate).toLocaleDateString();
          var roleName = myAccessItem.PermissionLevel != myAccessItem.PermissionGroup
            ? myAccessItem.PermissionGroup + "-" + myAccessItem.PermissionLevel
            : myAccessItem.PermissionLevel;
          var roleDefinitionId = myAccessItem.RoleDefinitionId ? myAccessItem.RoleDefinitionId : myAccessItem['role'] ? myAccessItem['role'].RoleId : "";

          // Check if role should be removable
          var isRemovable = !((roleName == UIConstants.PermissionTypes.MercuryInforma && myAccessData.filter(x => x.PermissionGroup.includes("P&L") || x.PermissionLevel.includes("Basic")).length > 0)
            || (roleName == "Basic Access" && myAccessData.filter(x => x.PermissionGroup.includes("P&L")).length > 0));

          approvedAccess.push({
            role: roleName,
            attributes: attributeValueString,
            attributeName: attrName,
            endDate: endDate,
            originalEndDate: myAccessItem.EndDate,
            roleId: roleDefinitionId,
            multiAttributes: multiAttributes,
            allowEdit: allowEdit,
            permissionLevel: myAccessItem.PermissionLevel,
            accessItem: myAccessItem,
            allowRemove: isRemovable,
            allowRenew: allowRenew,
            roleAllowRenew: roleAllowRenew
          });
        }

        approvedAccess.forEach(x => currentApprovedAccessItems.push(x));
      }
    }
    // External AAD Tenant Processing
    else if (this.tenantData?.isExternalAADTenant && MyAccess && MyAccess.Data) {
      myAccessData = MyAccess.Data.approvedAccess;
      for (const accessItem of myAccessData) {
        var attr = null;
        var attrName = '';
        var multiAttributes: any[] = [];

        if (accessItem.role !== null && accessItem.role.attributes?.length > 0) {
          // Use the new generic array processing method
          const result = this.processAttributesFromArray(
            accessItem.role.attributes,
            false,
            accessItem.role.roleName
          );

          multiAttributes = result.multiAttributes;
          attr = result.attr;
          attrName = result.attrName;
        }
        var allowRenew = false;
        var roleAllowRenew = false;
        var selectedRole = roleData.find(x => x.id == accessItem.role.roleDefinitionId);
        if (selectedRole) {
          var permissionAction = selectedRole.permissions[0].actions;
          if (permissionAction) {
            roleAllowRenew = permissionAction.find(x => x.indexOf(UIConstants.RoleDefinition.AllowRenewFlag) > -1) ? true : false;
          }
        }
        var diffInDays = Math.floor((new Date(accessItem.endDate).getTime() - new Date().getTime()) / MS_PER_DAY);
        allowRenew = roleAllowRenew && diffInDays <= this.state.accessExpiryReminderWindowDays;
        approvedAccess.push({
          role: accessItem.role.roleName,
          attributes: attr,
          attributeName: attrName,
          endDate: new Date(accessItem.endDate).toLocaleString().split(",")[0],
          originalEndDate: accessItem.endDate,
          roleId: accessItem.role.roleId,
          multiAttributes: multiAttributes,
          roleAssignmentId: accessItem.id,
          allowEdit: false,
          allowRemove: true,
          requestedFor: this.tenantData?.isExternalAADTenant ? accessItem.requestorUPN : null,
          allowRenew: allowRenew,
          roleAllowRenew: roleAllowRenew
        });
      }
    }
    // Standard Tenant Processing
    else if (MyAccess && MyAccess.Data) {
      myAccessData = MyAccess.Data.approvedAccess;
      if (myAccessData) {
        for (const myAccessItem of myAccessData) {
          var multiAttributes: any[] = [];
          var attributeValueString = '';
          var attrName = '';
          // Process all attributes dynamically using the generic object processing method
          if (myAccessItem.attributes) {
            multiAttributes = this.processAttributesFromObject(
              myAccessItem.attributes,
              multiAttributes,
              false
            );
            // Build attribute value string from multiAttributes for backward compatibility
            if (multiAttributes.length > 0) {
              attrName = multiAttributes[0].attributeName;
              attributeValueString = multiAttributes.map(ma => ma.attributeValueText).join('; ');
            }
          }

          allowEdit = false;
          let allowRenew = false;
          let roleAllowRenew = false;
          let selectedRole = roleData.find(x => x.id == myAccessItem.roleDefinitionId);
          if (selectedRole) {
            let permissionAction = selectedRole.permissions[0].actions;
            if (permissionAction) {
              allowEdit = permissionAction.find(x => x.indexOf(UIConstants.RoleDefinition.AllowEditFlag) > -1) ? true : false;
              roleAllowRenew = permissionAction.find(x => x.indexOf(UIConstants.RoleDefinition.AllowRenewFlag) > -1) ? true : false;
            }
          }
          let diffInDays = Math.floor((new Date(myAccessItem.endDate).getTime() - new Date().getTime()) / MS_PER_DAY);
          allowRenew = roleAllowRenew && diffInDays <= this.state.accessExpiryReminderWindowDays;
          let endDate = new Date(myAccessItem.endDate).toLocaleDateString();
          let roleName = myAccessItem.roleName ? myAccessItem.roleName : myAccessItem['role'] ? myAccessItem['role'].roleName : "";
          let roleDefinitionId = myAccessItem.roleDefinitionId ? myAccessItem.roleDefinitionId : myAccessItem['role'] ? myAccessItem['role'].roleId : "";
          if (multiAttributes.length == 1 && multiAttributes[0].attributeName == "BusinessGroup") {
            attributeValueString?.split("; ").forEach(attribute => {
              let _multiAttributes = [{ attributeName: attrName, attributeValueText: attribute }]
              approvedAccess.push({
                role: roleName,
                attributes: attribute,
                attributeName: attrName,
                endDate: endDate,
                originalEndDate: myAccessItem.endDate,
                roleId: roleDefinitionId,
                multiAttributes: _multiAttributes,
                allowEdit: allowEdit,
                allowRemove: true,
                allowRenew: allowRenew,
                roleAllowRenew: roleAllowRenew
              });
            });
          }
          else {
            approvedAccess.push({
              role: roleName,
              attributes: attributeValueString,
              attributeName: attrName,
              endDate: endDate,
              originalEndDate: myAccessItem.endDate,
              roleId: roleDefinitionId,
              multiAttributes: multiAttributes,
              allowEdit: allowEdit,
              allowRemove: true,
              allowRenew: allowRenew,
              roleAllowRenew: roleAllowRenew
            });
          }
          if (hasOEMAccess && roleName == UIConstants.RoleDefinition.MSSalesBasicRole) {
            approvedAccess.push({
              role: "OEM User",
              attributes: OEMSecurityTypeName,
              attributeName: "OEMSecurityType",
              endDate: "Not Applicable",
              originalEndDate: null,
              roleId: '',
              multiAttributes: [],
              allowEdit: false,
              allowRemove: false,
              allowRenew: allowRenew,
              roleAllowRenew: false
            })
          }
        }
      }
    } else {

    }
    return approvedAccess;
  }

  private getPendingItems = () => {
    const { MyAccess, MercuryAccess } = this.state;
    const { tenantName } = this.props;
    let pendingAccess = [];
    let myAccessData = null;
    if (isMercuryTenant(tenantName) && MercuryAccess?.Data) {
      myAccessData = MercuryAccess.Data.filter(item => item.status == 'InProgress')
    }
    else if (MyAccess && MyAccess?.Data) {
      myAccessData = MyAccess.Data.pendingRequests;
    }
    if (myAccessData) {
      for (const accessItem of myAccessData) {
        let attr = null;
        let attrName = '';
        let multiAttributes: any[] = [];
        if (accessItem.role !== null && accessItem.role.attributes?.length > 0) {
          // Use the new generic array processing method - it handles ALL attributes dynamically
          const result = this.processAttributesFromArray(
            accessItem.role.attributes,
            isMercuryTenant(tenantName),
            accessItem.role.roleName
          );
          multiAttributes = result.multiAttributes;
          attr = result.attr;
          attrName = result.attrName;
        }
        pendingAccess.push({
          requestId: accessItem.id,
          role: (isMercuryTenant(accessItem.tenantName) && accessItem.role.group != accessItem.role.roleName) ? (`${accessItem?.role?.group}-${accessItem?.role?.roleName}`) : accessItem.role.roleName,
          roleId: accessItem.role.roleId,
          attributes: attr,
          attributeName : attrName,
          multiAttributes: multiAttributes,
          requestedBy: this.tenantData?.isExternalAADTenant
            ? (accessItem.requestedBy.split("@")[0] != accessItem.requestorUPN.split("@")[0]
              ? accessItem.requestedBy.split("@")[0] + ' (On Behalf - Bulk)'
              : accessItem.requestedBy.split("@")[0])
            : (accessItem.requestedBy ?? accessItem.requestorUPN).split("@")[0],
          requestType: (isMercuryTenant(accessItem.tenantName))
            ? (accessItem.properties?.editRequest ? "Update" : "Add")
            : accessItem.requestType,
          requestDate: new Date(accessItem.requestedDate).toLocaleString(),
          status: accessItem.status,
          requestedFor: this.tenantData?.isExternalAADTenant ? accessItem.properties.onBehalfExternalUser : null
        });
      }
    }
    return pendingAccess;
  }

  private onEditBtnClick = (item: any, isRenewRequest) => {
    const { tenantName } = this.props;

    // Mercury, Alfred, and MDS tenants: pass individual item
    if (isMercuryTenant(tenantName) || tenantName == UIConstants.Tenant.Alfred || tenantName == UIConstants.Tenant.MDS) {
      this._closeModal(item, isRenewRequest);
    } 
    // MSSales tenant: pass filtered array (only items with DefaultReportingSubsidiary)
    else if (tenantName == UIConstants.Tenant.MSSales) {
      this._closeModal(this.state.MyAccess.Data.approvedAccess.filter(x => x.attributes != null && x.attributes.DefaultReportingSubsidiary != null), isRenewRequest);
    }
    else {
      this._closeModal(item, isRenewRequest);
    }
  }
}
